export const formatAmount = (amount: number): string =>
  `₹${Number(amount || 0).toLocaleString("en-IN")}`;

export const normalizePaymentStatus = (bookingDetails: any, prepaidPayment: any): string =>
  String(
    bookingDetails?.payment_status ??
      (typeof prepaidPayment?.status === "string"
        ? prepaidPayment.status
        : prepaidPayment?.status === true
          ? "true"
          : prepaidPayment?.status === false
            ? "false"
            : ""),
  )
    .trim()
    .toLowerCase();

export const resolvePaymentDisplayStatus = (bookingDetails: any, prepaidPayment: any): string =>
  bookingDetails?.payment_status ||
  (typeof prepaidPayment?.status === "string"
    ? prepaidPayment.status
    : prepaidPayment?.status === true
      ? "Paid"
      : prepaidPayment?.status === false
        ? "Pending"
        : "");
